import { useTranslation } from 'react-i18next';
import PaginaTexto from '../Compartido/PaginaTexto.jsx';

const TextosClientes = ({ clientes, ruta }) => {

    const { t } = useTranslation();

    return (
        <PaginaTexto
            titulo={t("Clientes")}
            eyebrow={t("Empresa")}
            imagen={clientes.imagen_cabecera ? ruta + "/" + clientes.imagen_cabecera : null}
            html={clientes.ladesc}
        />
    );
}

export default TextosClientes;
